const fetchWrapper: typeof fetch = (arg1: any, ...args: any[]) => {
  if (process.env.NODE_ENV === "development") {
    console.info(`Request`, arg1, ...args);
  }

  return fetch(arg1, ...args);
};

export default fetchWrapper;
